import { useMemo } from "react";
import { TP_Building, modelId } from "../../automationObjects/Plants/Buildings/P_Building";
import { useGetObjectsWithModelQuery } from "../../services/objects";
import { IAutomationObject } from "../../automationObjects";

interface useGetBuildingsOutput {
    count: number,
    items: TP_Building[] | undefined,
    error: any,
    isLoading: boolean,
    isSuccess: boolean
}

function useGetBuildings(): useGetBuildingsOutput {
    const { data, error, isLoading, isSuccess } = useGetObjectsWithModelQuery( { twinModelId: modelId });

    const buildings = useMemo(() => data ? [...data].sort((a, b) => a.description?.localeCompare(b.description)) : [], [data]);

    return {
        count: buildings?.length || 0,
        items: buildings,
        error: error,
        isLoading: isLoading,
        isSuccess: isSuccess,
    }
}

export default useGetBuildings
